// @ts-nocheck
import type * as Types from '../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import { PageFragmentFragmentDoc } from '../../../../../graphql/pages';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GoalFragment = { __typename?: 'Goal', id: string, amount: number, description: string, endDate?: number | null, startDate?: number | null };

export type DonationTierFragment = { __typename?: 'DonationTier', id: string, amount: number, recurrenceInterval: Types.DonationRecurrenceInterval, description: string, isDefault: boolean };

export type FundraiserFragment = { __typename?: 'Fundraiser', id: string, created: number, name: string, profilePictureUrl?: string | null, description?: string | null, raised: number };

export type PageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename?: 'Page', id: string, type: Types.PageType, created: number, title: string, status: Types.PageStatus, story?: string | null, pageUrl?: string | null, defaultDonorCoverFeesValue: boolean, smsMarketingEnabled: boolean, hasImage: boolean, imageUrl: string, videoUrl?: string | null, slug?: string | null, color: string, currentAmount: number, defaultDonationRecurrenceInterval: Types.DonationRecurrenceInterval, allowCustomAmount: boolean, donationTiersOrder: Types.DonationTiersOrder, enableTipping: boolean, fundraisersTitle: string, nonprofit: { __typename?: 'PageNonprofit', webId: string, name: string, logoUrl?: string | null, taxId: string, taxNote: string, tipNote: string, doubleTheDonationPublicKey?: string | null }, goals: Array<{ __typename?: 'Goal', id: string, amount: number, description: string, endDate?: number | null, startDate?: number | null }>, donationTiers: Array<{ __typename?: 'DonationTier', id: string, amount: number, recurrenceInterval: Types.DonationRecurrenceInterval, description: string, isDefault: boolean }>, fundraisers: Array<{ __typename?: 'Fundraiser', id: string, created: number, name: string, profilePictureUrl?: string | null, description?: string | null, raised: number }>, pageFeatures: { __typename?: 'PageFeatures', communityTab: boolean, peerToPeerTab: boolean, allocations: boolean, donationAmount: boolean, chariotButton: boolean, addressForm: boolean, donorCoversFees: boolean }, allocations: Array<{ __typename?: 'PublicAllocation', id: string, name: string }>, customDomain?: { __typename?: 'CustomDomain', id: string, domain: string, isValid: boolean } | null } };

export type UnpublishPageMutationVariables = Types.Exact<{
  input: Types.UnpublishPageInput;
}>;


export type UnpublishPageMutation = { __typename?: 'Mutation', unpublishPage: { __typename?: 'Page', id: string, status: Types.PageStatus } };

export type ValidatePageMutationVariables = Types.Exact<{
  input: Types.ValidatePageInput;
}>;


export type ValidatePageMutation = { __typename?: 'Mutation', validatePage: { __typename?: 'ValidatePageResult', success: boolean } };

export type ClosePageMutationVariables = Types.Exact<{
  input: Types.ClosePageInput;
}>;


export type ClosePageMutation = { __typename?: 'Mutation', closePage: { __typename?: 'Page', id: string, title: string, imageUrl: string, status: Types.PageStatus, slug?: string | null, fundraisersTitle: string, defaultDonorCoverFeesValue: boolean, color: string, pageFeatures: { __typename?: 'PageFeatures', communityTab: boolean, peerToPeerTab: boolean, allocations: boolean, donationAmount: boolean, chariotButton: boolean, addressForm: boolean, donorCoversFees: boolean } } };

export const GoalFragmentDoc = /*#__PURE__*/ gql`
    fragment Goal on Goal {
  id
  amount
  description
  endDate
  startDate
}
    `;
export const DonationTierFragmentDoc = /*#__PURE__*/ gql`
    fragment DonationTier on DonationTier {
  id
  amount
  recurrenceInterval
  description
  isDefault
}
    `;
export const FundraiserFragmentDoc = /*#__PURE__*/ gql`
    fragment Fundraiser on Fundraiser {
  id
  created
  name
  profilePictureUrl
  description
  raised
}
    `;
export const PageDocument = /*#__PURE__*/ gql`
    query Page($id: ID!) {
  page(id: $id) {
    id
    type
    created
    title
    status
    story
    pageUrl
    defaultDonorCoverFeesValue
    nonprofit {
      webId
      name
      logoUrl
      taxId
      taxNote
      tipNote
      doubleTheDonationPublicKey
    }
    smsMarketingEnabled
    hasImage
    imageUrl
    videoUrl
    slug
    color
    currentAmount
    defaultDonationRecurrenceInterval
    allowCustomAmount
    goals {
      ...Goal
    }
    donationTiersOrder
    donationTiers {
      ...DonationTier
    }
    enableTipping
    fundraisers {
      ...Fundraiser
    }
    fundraisersTitle
    pageFeatures {
      communityTab
      peerToPeerTab
      allocations
      donationAmount
      chariotButton
      addressForm
      donorCoversFees
    }
    allocations {
      id
      name
    }
    customDomain {
      id
      domain
      isValid
    }
  }
}
    ${GoalFragmentDoc}
${DonationTierFragmentDoc}
${FundraiserFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export function usePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export function refetchPageQuery(variables: PageQueryVariables) {
      return { query: PageDocument, variables: variables }
    }
export const UnpublishPageDocument = /*#__PURE__*/ gql`
    mutation UnpublishPage($input: UnpublishPageInput!) {
  unpublishPage(input: $input) {
    id
    status
  }
}
    `;

/**
 * __useUnpublishPageMutation__
 *
 * To run a mutation, you first call `useUnpublishPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishPageMutation, { data, loading, error }] = useUnpublishPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpublishPageMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishPageMutation, UnpublishPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishPageMutation, UnpublishPageMutationVariables>(UnpublishPageDocument, options);
      }
export type UnpublishPageMutationHookResult = ReturnType<typeof useUnpublishPageMutation>;
export const ValidatePageDocument = /*#__PURE__*/ gql`
    mutation ValidatePage($input: ValidatePageInput!) {
  validatePage(input: $input) {
    success
  }
}
    `;

/**
 * __useValidatePageMutation__
 *
 * To run a mutation, you first call `useValidatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePageMutation, { data, loading, error }] = useValidatePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePageMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePageMutation, ValidatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePageMutation, ValidatePageMutationVariables>(ValidatePageDocument, options);
      }
export type ValidatePageMutationHookResult = ReturnType<typeof useValidatePageMutation>;
export const ClosePageDocument = /*#__PURE__*/ gql`
    mutation ClosePage($input: ClosePageInput!) {
  closePage(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __useClosePageMutation__
 *
 * To run a mutation, you first call `useClosePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closePageMutation, { data, loading, error }] = useClosePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClosePageMutation(baseOptions?: Apollo.MutationHookOptions<ClosePageMutation, ClosePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosePageMutation, ClosePageMutationVariables>(ClosePageDocument, options);
      }
export type ClosePageMutationHookResult = ReturnType<typeof useClosePageMutation>;